import styled, { css } from 'styled-components';
import { ButtonProps } from './props';
import Color from 'color';
import Link from '@/components/core/Link';
import { getComputedColor } from '@/utils/theme';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

export const Button = styled(Link)<ButtonProps>`
  all: unset;
  box-sizing: border-box;
  width: 100%;
  height: ${({ theme }) => theme.vars.shape.boxHeight};
  min-height: ${({ theme }) => theme.vars.shape.boxHeight};
  border: none;
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  background-color: ${({ theme }) => theme.vars.palette.primary.main};
  color: ${({ theme }) => theme.vars.palette.primary.contrastText};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  opacity: ${({ disabled }) => (disabled ? '0.7' : '1')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.25s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => theme.vars.palette.secondary.main};
  }

  ${({ secondaryStyles }) =>
    secondaryStyles &&
    css`
      color: ${({ theme }) => theme.vars.palette.text.secondary} !important;
      background-color: ${({ theme }) =>
        Color(getComputedColor(theme.vars.palette.background.paper))
          .lighten(0.3)
          .toString()};
      transition:
        background 0.25s ease-in-out,
        color 0.25s ease-in-out;

      &:hover {
        background-color: ${({ theme }) =>
          Color(getComputedColor(theme.vars.palette.background.default))
            .lighten(0.5)
            .toString()};
        color: ${({ theme }) => theme.vars.palette.text.primary} !important;
      }
    `}
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.vars.palette.text.secondary};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.vars.palette.text.primary};
  font-size: 18px;
  font-weight: 500;
`;
